import { ActionTree } from 'vuex';
import { ReportState } from '../stores/report.store';
import { RootState } from '../store';
import {
  mutationSetIsLoading,
  mutationSetShowAll,
  mutationSetShowTeam,
} from '../mutations/report.mutations';

export const actionSetIsLoading = 'setIsLoading';
export const actionSetShowAll = 'setShowAll';
export const actionSetShowTeam = 'setShowTeam';

export const actions: ActionTree<ReportState, RootState> = {
  async [actionSetIsLoading]({ commit }, payload: boolean) {
    commit(mutationSetIsLoading, payload);
  },
  async [actionSetShowAll]({ commit }, payload: boolean) {
    commit(mutationSetShowAll, payload);
  },
  async [actionSetShowTeam]({ commit }, payload: boolean) {
    commit(mutationSetShowTeam, payload);
  },
};
